import Vue from 'vue'

import 'normalize.css/normalize.css'// A modern alternative to CSS resets

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import locale from 'element-ui/lib/locale/lang/zh-CN' // lang i18n
// import VCharts from 'v-charts'
import VueWait from 'vue-wait'

import '@/styles/index.scss' // global css
import '@/styles/custom.scss'
import App from './App'
import router from './router'
import store from './store'

import '@/icons' // icon
import '@/permission' // permission control

Vue.use(ElementUI, { locale })
// Vue.use(VCharts)
Vue.use(VueWait) // 局部loading控制 可结合 vuex

Vue.config.productionTip = false

new Vue({
	el: '#app',
	router,
	store,
	template: '<App/>',
	wait: new VueWait({
		useVuex: true,
		registerComponent: true,     // Registers `v-wait` component
		componentName: 'v-wait',     // <v-wait> component name, you can set `my-loader` etc.
		registerDirective: true,     // Registers `v-wait` directive
		directiveName: 'wait',       // <span v-wait /> directive name, you can set `my-loader` etc.
	}),
	components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js